import React from "react";
import ItemUnitListView from "presentational/common/itemUnit/ItemUnitListView";
import CommonMoreRequestButton from "presentational/common/CommonMoreRequestButton";
import { getDeviceType } from "lib/deviceInfo";
import Typography from "@material-ui/core/Typography";
import config from "lib/fr-config";
import BottomScrollListener from "react-bottom-scroll-listener";
import PropTypes from "prop-types";

const mobileCss = config.css.mobile;
const desktopCss = config.css.desktop;
const commonCss = config.css.commonDevice;

const cssXS = {
  root: {
    marginBottom: mobileCss.paddingOfScrollEnd
  },
  emptyListTextWrapper: {
    display: "flex",
    justifyContent: "center",
    marginBottom: 50
  },
  emptyListText: { fontSize: 14 }
};
const cssXL = {
  root: {
    marginBottom: desktopCss.paddingOfScrollEnd
  },
  emptyListTextWrapper: {
    display: "flex",
    justifyContent: "center",
    marginBottom: 50
  },
  emptyListText: { fontSize: 16 }
};

UsersItemUnitListView.propTypes = {
  itemList: PropTypes.array.isRequired,
  isItemListLoading: PropTypes.bool.isRequired,
  isItemListEnd: PropTypes.bool.isRequired,
  onItemClick: PropTypes.func.isRequired,
  onNextItemListRequest: PropTypes.func.isRequired,

  markedList: PropTypes.array,
  deleteMode: PropTypes.bool,

  emptyListText: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
};

UsersItemUnitListView.defaultProps = {
  emptyListText: null
};

function UsersItemUnitListView(props) {
  const {
    itemList,
    isItemListLoading,
    isItemListEnd,
    onItemClick,
    onNextItemListRequest,
    markedList,
    deleteMode,
    emptyListText
  } = props;

  const handleNextListRequest = () => {
    if (isItemListLoading) return null;
    onNextItemListRequest();
  };

  const textOfEmptyList = () => {
    if (!emptyListText) return null;

    const deviceType = getDeviceType();
    const css = deviceType === "mobile" ? cssXS : cssXL;

    return (
      <div style={css.emptyListTextWrapper}>
        <Typography variant="h4" style={css.emptyListText}>
          {emptyListText}
        </Typography>
      </div>
    );
  };

  const getList = () => {
    return (
      <div>
        <ItemUnitListView
          itemList={itemList}
          onItemClick={onItemClick}
          markedList={markedList}
          deleteMode={deleteMode}
        />
        {!isItemListLoading && itemList.length === 0 && textOfEmptyList()}
      </div>
    );
  };

  const render = () => {
    const deviceType = getDeviceType();
    const css = deviceType === "mobile" ? cssXS : cssXL;
    const scrollOffset =
      deviceType === "mobile"
        ? commonCss.scrollListenerOffset + mobileCss.paddingOfScrollEnd
        : commonCss.scrollListenerOffset + desktopCss.paddingOfScrollEnd;

    return (
      <div style={css.root}>
        <BottomScrollListener
          onBottom={handleNextListRequest}
          debounce={10}
          offset={scrollOffset}
        />
        {getList()}
        {!isItemListEnd && (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <CommonMoreRequestButton
              onClick={handleNextListRequest}
              isLoading={isItemListLoading}
            />
          </div>
        )}
      </div>
    );
  };

  return render();
}

export default UsersItemUnitListView;
